import React, { Component, Fragment } from "react";
import Modal from "../Modal";
import SuccessIcon from "../../src/Resources/SuccessIcon";
import Button from "../../src/Resources/Forms/Button";
import "../../src/Styles/Pages/successmodal.scss";

class SuccessModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showBody: false,
		};
	}

	componentDidMount() {
		setTimeout(
			() => {
				this.setState({ showBody: true });
			},
			this.props.multiButtons ? 1000 : 0,
		);
	}

	render() {
		return (
			<Modal
				closeModal={() => this.props.close()}
				isSmall={true}
				width={this.props.width || "400px"}
				isHeaderClose={true}
				preventClose={this.props.hideCloseStar}
			>
				<div className="success-modal">
					<div className="success-modal-icon">
						<SuccessIcon />
					</div>

					<div
						style={{ opacity: this.state.showBody ? 1 : 0 }}
						className="success-modal"
					>
						{this.props.text ? (
							<div className="success-modal-text">{this.props.text}</div>
						) : null}
						{this.props.subText && (
							<div
								className="success-modal-subtext"
								dangerouslySetInnerHTML={{ __html: this.props.subText }}
							/>
						)}
						{!this.props.multiButtons ? (
							<Fragment>
								{this.props.btnAction && this.props.btnText ? (
									<div className="success-modal-button">
										<Button
											type={this.props.btnType || "outline"}
											text={this.props.btnText}
											onClick={() => this.props.btnAction()}
										/>
									</div>
								) : (
									<div className="success-modal-button">
										<Button
											type={this.props.btnType || "default"}
											text={this.props.closeText || "Close"}
											onClick={() => this.props.close()}
										/>
									</div>
								)}
							</Fragment>
						) : (
							<div className="success-modal-multibuttons">
								<div style={{ marginRight: "15px" }}>
									<Button
										type={"default"}
										text={this.props.closeText || "Close"}
										onClick={() => this.props.close()}
									/>
								</div>
								<Button
									type={"primary"}
									text={this.props.confirmText || "Confirm"}
									onClick={() => this.props.confirmAction()}
									noMargin={true}
								/>
							</div>
						)}
					</div>
				</div>
			</Modal>
		);
	}
}

export default SuccessModal;
